import { takeLatest, call, put, all, cancelled } from "redux-saga/effects"
import axios from "axios"
import _, { flatMap, filter, orderBy } from "lodash"

import { push } from "connected-react-router"

import {
  GET_SEGMENTS_WATCHER,
  GET_SURVEY_TYPES_WATCHER,
  GET_SCOPE_TYPES_WATCHER,
  CREATE_MEASUREMENT_WATCHER,
  GET_ORGANIZATION_SURVEYS_WATCHER,
  GET_SEGMENTS_SURVEYS_WATCHER,
} from "./constants"

import {
  getSegmentsSuccess,
  getSegmentsFailed,
  getSurveyTypesSuccess,
  getSurveyTypesFailed,
  getScopeTypesSuccess,
  getScopeTypesFailed,
  createMeasurementSuccess,
  createMeasurementFailed,
  getOrganizationSurveysSuccess,
  getOrganizationSurveysFailed,
  getSegmentsSurveysSuccess,
  getSegmentsSurveysFailed,
} from "./actions"

import {
  LOCAL_COMPANY_ID,
  LOCAL_COMPANY_NAME,
  LOCAL_TOKEN,
} from "../../../utils/storage"
import {
  getScopeTypesApi,
  getSegmentsApi,
  getSurveyTypesApi,
  getSurveyTypesCreateApi,
} from "../../../utils/routes/routes-survey"
import { getSurveyWatcherApi } from "../../Survey/saga"
import { createMeasureSegment } from "../../../utils/segment/Measure/measureTrack"

function messageProgress(messagex) {
  message.loading(messagex, 0)
}

function messageSuccess(messagex) {
  message.success(messagex, 5)
}

function messageFailed(messagex) {
  message.error(messagex, 5)
}

function messageDestroy() {
  message.destroy()
}

export function getSegmentsWithSurveysApi(id_survey_type) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }surveys/survey-has-segment?id_survey_type=${id_survey_type}&id_company=${LOCAL_COMPANY_ID()}`,
  })
}

export function* getSegmentsSaga(action) {
  try {
    const { data, status } = yield call(
      getSegmentsWithSurveysApi,
      action.payload
    )
    if (status === 200) {
      yield put(getSegmentsSuccess(data.data))
    }
  } catch (error) {
    yield put(getSegmentsFailed())
    returnMessage(error)
  }
}

export function* getSurveyTypesSaga() {
  try {
    const { data, status } = yield call(getSurveyTypesCreateApi)
    
    if (status === 200) {
      yield put(getSurveyTypesSuccess(data))
    }
  } catch (error) {
    yield put(getSurveyTypesFailed())
    returnMessage(error)
  }
}

export function* getScopeTypesSaga() {
  try {
    const { data, status } = yield call(getScopeTypesApi)
    if (status === 200) {
      yield put(getScopeTypesSuccess(data.data))
    }
  } catch (error) {
    yield put(getScopeTypesFailed())
    returnMessage(error)
  }
}

// CREATE MEASUREMENT
export function* createMeasurementWatcherSaga(action) {
  try {
    const { data, status } = yield call(fetchGlobalApi, {
      method: "POST",
      endpoint: "measure/wizard/initialize",
      data: action.payload,
    })

    // const survey = yield call(getSurveyWatcherApi, action.payload.id_survey)
    if (status === 200) {
      // createMeasureSegment(action.payload.name, survey.data.data.survey)
      yield put(createMeasurementSuccess(data))
      yield put(push(`/models/measure-create/${data.measure_id}?step=2`))
    }
  } catch (error) {
    yield put(createMeasurementFailed())
    returnMessage(error)
  }
}

export function getOrganizationSurveysApi(id_survey_type) {
  return axios.request({
    method: "GET",
    headers: { Authorization: `Bearer ${LOCAL_TOKEN()}` },
    url: `${
      process.env.API_URL
    }companies/${LOCAL_COMPANY_ID()}/available-surveys?id_survey_type=${id_survey_type}&scope_type=1`,
  })
}

export function* getOrganizationSurveysSaga(action) {
  try {
    const { data, status } = yield call(
      getOrganizationSurveysApi,
      action.payload
    )
    if (status === 200) {
      yield put(getOrganizationSurveysSuccess(data.data))
    }
  } catch (error) {
    yield put(getOrganizationSurveysFailed())
    returnMessage(error)
  }
}

export default function* measurementNewSaga() {
  yield takeLatest(GET_SEGMENTS_WATCHER, getSegmentsSaga)
  yield takeLatest(GET_SURVEY_TYPES_WATCHER, getSurveyTypesSaga)
  yield takeLatest(GET_SCOPE_TYPES_WATCHER, getScopeTypesSaga)
  yield takeLatest(CREATE_MEASUREMENT_WATCHER, createMeasurementWatcherSaga)
  yield takeLatest(GET_ORGANIZATION_SURVEYS_WATCHER, getOrganizationSurveysSaga)
}
